import { NewImage } from "pages/slicer/[id]"
import React, { Dispatch, SetStateAction } from "react"
import { BigNumberish, BytesLike, utils } from "ethers"
import useEthUsd from "@utils/useEthUsd"
import { availableCurrencies } from "../AddProductFormPrice/AddProductFormPrice"
import { parseEther, parseUnits } from "viem"
import { View } from "@components/modals/types"

type Props = {
  slicerId: number
  name: string
  shortDescription: string
  description: string
  newImage: NewImage
  maxUnits: number
  isLimited: boolean
  units: number
  ethValue: number | string
  usdValue: number | string
  isUSD: boolean
  thankMessage: string
  instructions: string
  notes: string
  files: File[]
  setModalView: Dispatch<SetStateAction<View>>
  externalCallValue: BigNumberish
  extAddress: string
  extCheckSig: BytesLike
  extExecSig: BytesLike
  currency: string
  externalAddress?: string
  redeemButton: boolean | undefined
  customPrice: number | undefined
}

const AddProductFormPreview = ({
  slicerId,
  name,
  shortDescription,
  description,
  newImage,
  maxUnits,
  isLimited,
  units,
  ethValue,
  usdValue,
  isUSD,
  thankMessage,
  instructions,
  notes,
  files,
  setModalView,
  externalCallValue,
  extAddress,
  extCheckSig,
  extExecSig,
  externalAddress,
  currency,
  redeemButton,
  customPrice
}: Props) => {
  const ethUsd = useEthUsd()
  const val = customPrice ? utils.formatEther(customPrice) : ethValue
  const usdVal = customPrice ? utils.formatUnits(customPrice, 6) : usdValue

  const externalCallEth = utils.formatEther(externalCallValue)
  const externalCallUsd = Number(externalCallEth) * Number(ethUsd)
  const productPrice = {
    eth: val
      ? "Ξ " + Math.floor((Number(val) + Number(externalCallEth)) * 1000) / 1000
      : "Free",
    usd: usdVal
      ? "$ " + Math.floor((Number(usdVal) + externalCallUsd) * 100) / 100
      : "$ 0",
    usdc: usdVal
      ? "USDC " + Math.floor((Number(usdVal) + externalCallUsd) * 100) / 100
      : "USDC 0"
  }

  return (
    <div>
      <div className="pb-10">
        <h1 className="pb-6">Review</h1>
        <p className="text-lg text-gray-600">
          Preview how the product and purchase views appear to buyers
        </p>
      </div>
      <div className="flex flex-wrap justify-around gap-4 pt-6">
        <a
          className="highlight"
          onClick={() =>
            setModalView({
              name: "PRODUCT_VIEW",
              cross: true,
              params: {
                price:
                  currency.toLowerCase() ===
                  availableCurrencies[0].value.toLowerCase()
                    ? parseEther(String(val || 0))
                    : parseUnits(String(usdVal || 0), 6),
                preview: true,
                slicerId,
                productId: 0,
                name: name || "A nice product",
                shortDescription,
                description,
                image: newImage.url,
                texts: {
                  thanks: thankMessage,
                  instructions: instructions
                },
                productPrice,
                extAddress,
                extValue: externalCallValue,
                extCheckSig,
                extExecSig,
                isUSD,
                allowedAddresses: [],
                isInfinite: !isLimited,
                maxUnits,
                availableUnits: units,
                totalPurchases: 0,
                purchaseInfo: {
                  files: files.length != 0,
                  instructions: instructions.length != 0,
                  notes: notes.length != 0
                },
                slicerAddress: "preview",
                purchasedQuantity: 0,
                availabilityColor:
                  units < 10
                    ? units == 0
                      ? "text-red-500"
                      : "text-yellow-600"
                    : "text-green-600",
                externalPriceAddress: externalAddress,
                isCustomPriced: externalAddress && true,
                currency
              }
            })
          }
        >
          Product view
        </a>
        <a
          className="highlight"
          onClick={() =>
            setModalView({
              name: "PURCHASE_PRODUCT_VIEW",
              cross: true,
              params: {
                slicerId,
                productId: 0,
                name: name || "A nice product",
                image: newImage.url,
                purchasedQuantity: Number(1),
                texts: {
                  thanks: thankMessage,
                  instructions: instructions
                },
                decryptedFiles: files,
                decryptedTexts: { notes },
                redeemButton
              }
            })
          }
        >
          Purchase view
        </a>
      </div>
    </div>
  )
}

export default AddProductFormPreview
